var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "banner swiper-banner",
      class: [{ on: _vm.componentContent.categoryShow }]
    },
    [
      _c(
        "swiper",
        {
          staticClass: "weekStore-swiper",
          attrs: { options: _vm.swiperOption }
        },
        _vm._l(_vm.bannerList, function(item, index) {
          return _c("swiper-slide", { key: index, staticClass: "store-box" }, [
            _c("a", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: item.bannerUrl,
                  expression: "item.bannerUrl"
                }
              ],
              staticClass: "a-link",
              style:
                "background-image:url(" +
                _vm.bannerImg +
                ");background-size:cover;background-position:center",
              on: {
                click: function($event) {
                  return _vm.jumpLink(item.linkObj)
                }
              }
            })
          ])
        }),
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "swiper-pagination" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-5a8c44c2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-5a8c44c2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/canvasShow/cereshop/pc_b2c/bannerSwiper.vue
// module id = null
// module chunks = 